import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { HIServiceMessage } from '../../features/patient/PatientContextSlice'

export type IhiValidationResult = {
  ihi_status?: string
  record_status?: string
  ihi_number?: string
  service_message?: HIServiceMessage | null
}

export interface PatientFormState {
  medicareValidationResult: IhiValidationResult
  dvaValidationResult: IhiValidationResult
  ihiValidationResult: IhiValidationResult
}

const defaultIhiValidationResult: IhiValidationResult = {
  ihi_status: '',
  record_status: 'Unverified',
  ihi_number: '',
  service_message: null,
}

const blankPatientFormState: PatientFormState = {
  medicareValidationResult: defaultIhiValidationResult,
  dvaValidationResult: defaultIhiValidationResult,
  ihiValidationResult: defaultIhiValidationResult,
}

export const PatientFormSlice = createSlice({
  name: 'patientForm',
  initialState: blankPatientFormState,
  reducers: {
    setMedicareValidationResult: (state, action: PayloadAction<IhiValidationResult>) => {
      state.medicareValidationResult = action.payload
    },
    setDvaValidationResult: (state, action: PayloadAction<IhiValidationResult>) => {
      state.dvaValidationResult = action.payload
    },
    setIhiValidationResult: (state, action: PayloadAction<IhiValidationResult>) => {
      state.ihiValidationResult = action.payload
    },
    resetMedicareValidationResult: (state) => {
      state.medicareValidationResult = defaultIhiValidationResult
    },
    resetDvaValidationResult: (state) => {
      state.dvaValidationResult = defaultIhiValidationResult
    },
    resetIhiValidationResult: (state) => {
      state.ihiValidationResult = defaultIhiValidationResult
    },
    resetAllValidationResults: (state) => {
      state.medicareValidationResult = defaultIhiValidationResult
      state.dvaValidationResult = defaultIhiValidationResult
      state.ihiValidationResult = defaultIhiValidationResult
    },
  },
})

export const {
  setMedicareValidationResult,
  setDvaValidationResult,
  setIhiValidationResult,
  resetMedicareValidationResult,
  resetDvaValidationResult,
  resetIhiValidationResult,
  resetAllValidationResults,
} = PatientFormSlice.actions

export default PatientFormSlice.reducer
